import { FunctionComponent, useState, useEffect } from 'react';
import { Avatar, Box, CardActions, Grid, Typography } from '@material-ui/core';
import i18n from 'i18n';
import {
  fetchStory,
  fetchStoryHistory,
  updateStory
} from 'pages/stories/actions';
import { User } from 'interface';
import { useDispatch } from 'react-redux';
import toggleNotification from 'actions/notifications';
import { getInitialState } from 'pages/stories/utils';
import { StoryFormData } from 'pages/stories/interface';
import ActionDialog from 'components/ActionDialogue';
import { HistoryRounded } from '@material-ui/icons';
import ContentBox from 'components/ContentBox';
import ContentBoxItem from 'components/ContentBoxItem';
import shortid from 'shortid';

interface HistoryI {
  story: string;
}

interface HistoryObject {
  guid: string;
  session: string;
  objectName: string;
  objectId: string;
  objectAttribute: string;
  objectAttributeType: string | undefined;
  previousValue: string | undefined;
  newValue: string | undefined;
  modifiedBy: User;
  modifiedAt: string;
}

const HistoryTab: FunctionComponent<HistoryI> = ({ story }: HistoryI) => {
  const [storyHistory, setStoryHistory] = useState<HistoryObject[]>([]);
  const [currentStory, setCurrentStory] = useState<StoryFormData>();
  const dispatch = useDispatch();

  useEffect(() => {
    fetchStoryHistory(story).then(({ data }) => {
      setStoryHistory([...data].reverse());
    });
    fetchStory(story).then(({ data }) => {
      setCurrentStory(getInitialState(data));
    });
  }, [story]);

  const revertChanges = (item: HistoryObject) => {
    if (!currentStory) return;

    const storyData: StoryFormData = {
      ...currentStory,
      [item.objectAttribute]: item.previousValue
    };

    updateStory(storyData).then(({ code }) => {
      if (code === 201) {
        dispatch(
          toggleNotification(
            i18n.t('notifications.stories.updateSuccess'),
            'success'
          )
        );
      }
    });
  };

  return (
    <Box>
      <Grid container style={{ overflowY: 'scroll' }}>
        {storyHistory &&
          storyHistory
            .filter(
              item =>
                !['created_at', 'story_state'].includes(item.objectAttribute)
            )
            .map(item => {
              return (
                <ContentBox
                  key={shortid()}
                  marginBottom={2}
                  style={{ width: '100%' }}
                >
                  <ContentBoxItem gridGap={16} alignItems="center !important">
                    <Grid item spacing={0}>
                      <Avatar aria-label="recipe">
                        {item.modifiedBy.username.split('')[0]}
                      </Avatar>
                    </Grid>
                    <Grid item xs={8}>
                      <Typography
                        variant="body1"
                        color="textPrimary"
                        component="p"
                      >
                        {item.modifiedBy.username}
                      </Typography>
                      <Typography
                        variant="body2"
                        color="textSecondary"
                        component="p"
                      >
                        {item.objectAttribute?.replace('_', ' ')}
                        {', '}
                        {new Date(item.modifiedAt).toLocaleString()}{' '}
                      </Typography>
                    </Grid>
                    <Grid item xs={2} style={{ marginLeft: 'auto' }}>
                      <CardActions style={{ float: 'right' }}>
                        <ActionDialog
                          onConfirm={() => revertChanges(item)}
                          target=" "
                          tooltip={i18n.t('button.revertChanges')}
                          icon={<HistoryRounded color="primary" />}
                          targetDeleteTitle={i18n.t('button.revertChanges')}
                          targetDeletePrompt={i18n.t(
                            'deleteDialog.archiveDialog'
                          )}
                          targetDeleteWarning={i18n.t('deleteDialog.warning')}
                          btnDisabled={false}
                        />
                      </CardActions>
                    </Grid>
                  </ContentBoxItem>
                </ContentBox>
              );
            })}
      </Grid>
    </Box>
  );
};

export default HistoryTab;

HistoryTab.defaultProps = {};
